import * as tslib_1 from "tslib";
import { IgrFormatSpecifier } from "./igr-format-specifier";
import { DateTimeFormatSpecifier as DateTimeFormatSpecifier_internal } from "./DateTimeFormatSpecifier";
var IgrDateTimeFormatSpecifier = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IgrDateTimeFormatSpecifier, _super);
    function IgrDateTimeFormatSpecifier() {
        return _super.call(this) || this;
    }
    IgrDateTimeFormatSpecifier.prototype.createImplementation = function () {
        return new DateTimeFormatSpecifier_internal();
    };
    Object.defineProperty(IgrDateTimeFormatSpecifier.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeFormatSpecifier.prototype, "locale", {
        get: function () {
            return this.i.l;
        },
        set: function (v) {
            this.i.l = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeFormatSpecifier.prototype, "dateStyle", {
        get: function () {
            return this.i.d;
        },
        set: function (v) {
            this.i.d = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeFormatSpecifier.prototype, "timeStyle", {
        get: function () {
            return this.i.r;
        },
        set: function (v) {
            this.i.r = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeFormatSpecifier.prototype, "fractionalSecondDigits", {
        get: function () {
            return this.i.b;
        },
        set: function (v) {
            this.i.b = +v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeFormatSpecifier.prototype, "calendar", {
        get: function () {
            return this.i.c;
        },
        set: function (v) {
            this.i.c = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeFormatSpecifier.prototype, "dayPeriod", {
        get: function () {
            return this.i.f;
        },
        set: function (v) {
            this.i.f = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeFormatSpecifier.prototype, "numberingSystem", {
        get: function () {
            return this.i.p;
        },
        set: function (v) {
            this.i.p = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeFormatSpecifier.prototype, "localeMatcher", {
        get: function () {
            return this.i.m;
        },
        set: function (v) {
            this.i.m = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeFormatSpecifier.prototype, "timeZone", {
        get: function () {
            return this.i.s;
        },
        set: function (v) {
            this.i.s = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeFormatSpecifier.prototype, "hour12", {
        get: function () {
            return this.i.j;
        },
        set: function (v) {
            this.i.j = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeFormatSpecifier.prototype, "hourCycle", {
        get: function () {
            return this.i.k;
        },
        set: function (v) {
            this.i.k = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeFormatSpecifier.prototype, "formatMatcher", {
        get: function () {
            return this.i.h;
        },
        set: function (v) {
            this.i.h = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeFormatSpecifier.prototype, "weekDay", {
        get: function () {
            return this.i.u;
        },
        set: function (v) {
            this.i.u = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeFormatSpecifier.prototype, "era", {
        get: function () {
            return this.i.g;
        },
        set: function (v) {
            this.i.g = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeFormatSpecifier.prototype, "year", {
        get: function () {
            return this.i.v;
        },
        set: function (v) {
            this.i.v = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeFormatSpecifier.prototype, "month", {
        get: function () {
            return this.i.o;
        },
        set: function (v) {
            this.i.o = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeFormatSpecifier.prototype, "day", {
        get: function () {
            return this.i.e;
        },
        set: function (v) {
            this.i.e = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeFormatSpecifier.prototype, "hour", {
        get: function () {
            return this.i.i;
        },
        set: function (v) {
            this.i.i = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeFormatSpecifier.prototype, "minute", {
        get: function () {
            return this.i.n;
        },
        set: function (v) {
            this.i.n = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeFormatSpecifier.prototype, "second", {
        get: function () {
            return this.i.q;
        },
        set: function (v) {
            this.i.q = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeFormatSpecifier.prototype, "timeZoneName", {
        get: function () {
            return this.i.t;
        },
        set: function (v) {
            this.i.t = v;
        },
        enumerable: true,
        configurable: true
    });
    return IgrDateTimeFormatSpecifier;
}(IgrFormatSpecifier));
export { IgrDateTimeFormatSpecifier };
//# sourceMappingURL=igr-date-time-format-specifier.js.map
